import { logger } from './index';

export const guestPortalLogger = logger.child({ module: 'guest-portal' });

export const registrationLogger = guestPortalLogger.child({ flow: 'registration' });

export const feedbackLogger = guestPortalLogger.child({ flow: 'feedback' });

export const apiLogger = logger.child({ module: 'api' });

export const authLogger = logger.child({ module: 'auth' });
